import { CHECKOUT_STATUS } from './CheckoutrequestPage';
import { CORRECTION_STATUS } from './correctionStatuses';

export const EVIDENCE_PORTAL_TAB_KEYS = {
  MY_EVIDENCE: 'my-evidence',
  CHECKOUT: 'checkout-requests',
  CORRECTIONS: 'corrections',
  SETTINGS: 'settings',
};

export const PORTAL_CHECKOUT_CLOSED_STATUS_CODES = [
  CHECKOUT_STATUS.COMPLETE.value,
  CHECKOUT_STATUS.CANCEL.value,
];

export const PORTAL_CHECKOUT_TABLE_COLUMN_LABELS = {
  item: 'Item',
  reason: 'Reason',
  requested: 'Requested',
  pickup: 'Pickup Date/Time',
  status: 'Status',
  comments: 'Comments',
  processedBy: 'Processed By',
};

export const PORTAL_CORRECTION_TABLE_COLUMN_LABELS = {
  evidenceId: 'Evidence ID',
  incident: 'Incident',
  reason: 'Reason',
  details: 'Details',
  status: 'Status',
  requested: 'Requested',
  requestedBy: 'Requested By',
};

export const PORTAL_CORRECTION_STATUS_CHIP_COLOR = {
  [CORRECTION_STATUS.OPEN]: 'error',
  [CORRECTION_STATUS.IN_PROGRESS]: 'warning',
  [CORRECTION_STATUS.RESOLVED]: 'success',
  [CORRECTION_STATUS.CLOSE]: 'default',
};

export const PORTAL_DASHBOARD_SUMMARY_DEFAULT = {
  total: 0,
  waiting: 0,
  inStorage: 0,
  checkedOut: 0,
  disposed: 0,
  overdueReturn: 0,
  overdueCheckouts: [],
};

export const PORTAL_STAT_TILES_CONFIG = [
  { key: 'total', label: 'My Records' },
  { key: 'inStorage', label: 'In Storage', statusCategory: 'IN' },
  { key: 'checkedOut', label: 'Checked Out', statusCategory: 'OUT' },
  { key: 'waiting', label: 'Awaiting Check-In', statusCategory: 'Waiting' },
  { key: 'disposed', label: 'Disposed', statusCategory: 'Disposed' },
];

export const PORTAL_ITEM_DETAIL_FIELDS = [
  ['Description', 'Description'],
  ['Category', 'Category'],
  ['Property Type', 'PropertyType'],
  ['Evidence Type', 'EvidenceType'],
  ['Quantity', 'Quantity'],
  ['Tag Number', 'TagNumber'],
  ['Make', 'Make'],
  ['Model', 'Model'],
  ['Serial Number', 'SerialNumber'],
  ['Condition', 'Condition'],
  ['Collected By', 'CollectedBy'],
  ['Date Collected', 'DateTimeCollected', true],
  ['Submitted By', 'SubmittedBy'],
  ['Submitted', 'SubmittedAt', true],
  ['Received By', 'ReceivedBy'],
  ['Received', 'ReceivedDate', true],
  ['Required Action', 'RequiredAction'],
  ['Action Date', 'ActionDate', true],
  ['Property Owner', 'PropertyOwner'],
  ['Offenses', 'Offenses'],
];

export const PORTAL_ITEM_DISPOSITION_FIELDS = [
  ['Disposed', 'IsDisposed', 'bool'],
  ['Ready for Disposal', 'ReadyForDisposal', 'bool'],
  ['Final Disposition', 'FinalDisposition'],
  ['Disposition Date', 'DispositionDate', true],
  ['Disposal Code', 'DisposalCode'],
  ['Disposed By', 'DisposedOfBy'],
  ['Destruction Method', 'DestructionMethod'],
  ['Destruction Date', 'DestructionDate', true],
  ['Released To', 'ReleasedTo'],
  ['Release Date', 'ReleaseDate', true],
  ['Court Case Number', 'CourtCaseNumber'],
];
